import ContractSpecs from './ContractSpecs';

export default ContractSpecs;
